import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL } from "@/config/campaign";
import { ChickenAvatar } from "@/components/Mascot";
import { Wordmark } from "@/components/Header";

export const LegalEntity = () => (
  <p data-testid="legal-entity">
    {LEGAL.entityName}
    <br />
    {LEGAL.address}
    <br />
    E-Mail: {LEGAL.email}
  </p>
);

export const LegalLayout = ({ title, children, testId }) => (
  <main className="min-h-screen bg-paper py-14 md:py-20" data-testid={testId}>
    <div className="mx-auto max-w-[760px] px-5">
      <Link
        to="/"
        data-testid="legal-back-link"
        className="inline-flex items-center gap-2 text-sm text-mutedlight transition-colors duration-200 hover:text-gold-dark"
      >
        <ArrowLeft className="h-4 w-4" strokeWidth={1.5} /> Zurück zum Wettbewerb
      </Link>
      <div className="mt-8 flex items-center gap-2.5">
        <ChickenAvatar className="h-7 w-7" />
        <Wordmark />
      </div>
      <h1 className="mt-5 font-display text-4xl font-extrabold tracking-tight text-ink md:text-5xl">{title}</h1>
      <div className="mt-8 space-y-8 text-sm leading-relaxed text-coal md:text-base">{children}</div>
    </div>
  </main>
);

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="mb-3 font-display text-xl font-extrabold tracking-tight text-ink">{title}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);
